'use client'
import { ListItem as ChakraListItem } from '@chakra-ui/react'
import { forwardRef, LegacyRef } from 'react'

import { ListItemProps } from './ListItem.types'

export default forwardRef(function ListItem(
  props: ListItemProps,
  ref: LegacyRef<HTMLDivElement>
) {
  return <ChakraListItem {...props} ref={ref} translate="no" />
})
